import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Dictionary } from '@/types';
import { FILTER_NAV, FILTER_TITLE, ORGANIZATIONS_ROUTE } from './const';
import { Departments, Municipalities } from './types';

@Component
export default class PageOrganizationsFilter extends Vue {
  // Vuex
  @State departments: Departments | null;
  @State municipalities: Municipalities;

  // Readonly
  readonly filterNav = FILTER_NAV;
  readonly filterTitle = FILTER_TITLE;
  readonly routeName: string = ORGANIZATIONS_ROUTE;

  // Computed
  get filterProps() {
    const {
      filterNav,
      filterTitle,
      localFilterFields,
      localFilterValues,
      routeName,
    } = this;
    return {
      title: filterTitle,
      route: routeName,
      key: JSON.stringify(localFilterValues),
      fields: localFilterFields,
      values: localFilterValues,
      nav: filterNav.map(el => ({...el, selected: el.to.name === this.$route.name})),
    };
  }

  get filterFields() {
    const { municipalities, departments } = this;
    const result = [];

    result.push({
      title: 'Муниципалитет',
      placeholder: 'Муниципалитет',
      code: 'municipality',
      data: [
        {
          name: 'Любой муниципалитет',
          id: '',
        },
        ...municipalities,
      ],
      filterable: 'auto',
    });

    result.push({
      title: 'Организации',
      placeholder: 'Организации',
      code: 'organization',
    });
  
    result.push({
      title: 'Тип',
      placeholder: 'Тип',
      code: 'role',
      data: [
        {
          name: 'Любой Тип',
          id: '',
        },
        ...this.$store.state.partnerRoleDict,
      ],
    });

    if (departments !== null && Array.isArray(departments)) {
      result.push({
        title: 'Ведомство',
        placeholder: 'Ведомство',
        code: 'department',
        data: [
          {
            name: 'Любое ведомство',
            id: '',
          },
          ...departments.map(({ name, id, short_name }) => ({
            id,
            name: short_name || name,
          })),
        ],
        // filterable: 'auto',
      });
    }

    return result;
  }

  get filterValues(): Dictionary<any> {
    return this.$route.query;
  }

  get localFilterValues() {
    return this.filterValues;
  }

  get localFilterFields() {
    const hidden = {
      type: 'hidden',
      code: 'limit',
    };
    return [...this.filterFields, hidden];
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/filter.ts